/* Team Work PWA — installation explicite et état hors connexion, sans données privées en cache. */
import { useEffect, useState } from "react";
import { CheckCircle2, Download, WifiOff, X } from "lucide-react";
import { trackDownload } from "@/components/AnalyticsTracker";
import { safeGet, safeSet } from "@/lib/storage";

export default function PwaExperience() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [online, setOnline] = useState(() => typeof navigator === "undefined" ? true : navigator.onLine);
  const [installed, setInstalled] = useState(() => (
    typeof window !== "undefined" && (window.matchMedia?.("(display-mode: standalone)").matches || Boolean(window.navigator.standalone))
  ));
  const [dismissed, setDismissed] = useState(() => safeGet(typeof window !== "undefined" ? window.sessionStorage : null, "tw_pwa_dismissed") === "1");

  useEffect(() => {
    const onBeforeInstall = (event) => { event.preventDefault(); setDeferredPrompt(event); };
    const onInstalled = () => { setInstalled(true); setDeferredPrompt(null); trackDownload({ item_id: "pwa", label: "Installation application Team Work" }); };
    const onOnline = () => setOnline(true);
    const onOffline = () => setOnline(false);

    window.addEventListener("beforeinstallprompt", onBeforeInstall);
    window.addEventListener("appinstalled", onInstalled);
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);
    return () => {
      window.removeEventListener("beforeinstallprompt", onBeforeInstall);
      window.removeEventListener("appinstalled", onInstalled);
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
    };
  }, []);

  const install = async () => {
    if (!deferredPrompt) return;
    await deferredPrompt.prompt();
    setDeferredPrompt(null);
  };

  return (
    <>
      {!online && <div className="fixed inset-x-3 bottom-24 z-[70] flex items-center gap-3 rounded-2xl bg-brand-navy px-4 py-3 text-sm font-semibold text-white shadow-2xl lg:inset-x-auto lg:bottom-5 lg:right-5 lg:max-w-sm" role="status" data-testid="offline-banner"><WifiOff className="h-4 w-4 shrink-0 text-brand-orange" /><span className="flex-1">Mode hors connexion. Les données Owner ne sont pas mises en cache.</span></div>}
      {!dismissed && online && (installed || deferredPrompt) && (
        <div className="fixed inset-x-3 bottom-24 z-[65] flex items-center gap-3 rounded-2xl border border-brand-orange/20 bg-white px-4 py-3 text-brand-navy shadow-2xl lg:inset-x-auto lg:bottom-5 lg:right-5 lg:max-w-sm" role="dialog" aria-label="Installer Team Work" data-testid="pwa-install-prompt">
          {installed ? <CheckCircle2 className="h-5 w-5 shrink-0 text-emerald-600" /> : <Download className="h-5 w-5 shrink-0 text-brand-orange" />}
          <div className="min-w-0 flex-1"><p className="text-sm font-extrabold">{installed ? "Team Work est installée" : "Télécharger Team Work"}</p><p className="mt-0.5 text-xs text-slate-500">{installed ? "L’application reste disponible depuis ton écran d’accueil." : "Accède plus vite aux offres depuis ton écran d’accueil."}</p></div>
          <button type="button" onClick={install} disabled={installed || !deferredPrompt} className={`rounded-xl px-3 py-2 text-xs font-extrabold text-white transition active:scale-95 ${installed ? "cursor-default bg-emerald-600" : "bg-brand-orange hover:bg-brand-orangeDark"}`}>{installed ? "Déjà installée" : "Télécharger"}</button>
          <button type="button" onClick={() => { safeSet(window.sessionStorage, "tw_pwa_dismissed", "1"); setDismissed(true); }} className="rounded-lg p-1 text-slate-400 hover:bg-slate-100 hover:text-brand-navy" aria-label="Fermer" data-testid="dismiss-pwa-install"><X className="h-4 w-4" /></button>
        </div>
      )}
    </>
  );
}
